(() => {
  window.swinger.app({
    type: 'in-place-registration',
    component: 'in-place-registration',
  });
})();



// WEBPACK FOOTER //
// ./src/widgets/in-place-registration/in-place-registration.js